import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { PrintersApiAdapter } from '../adapters/PrintersApiAdapter';

export const usePrintersSettings = () => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PrintersApiAdapter(httpClient);

  const {
    data: settings,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['printersSettings'],
    queryFn: () => apiAdapter.getSettings(),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    settings: settings || { print_node_api_key: '', printing_method: 'pdf' },
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
